import { defineMessages } from 'react-intl';

var messages = defineMessages({
  noResultsFound: {
    id: "neptune.SelectInput.noResultsFound"
  }
});

export { messages as default };
//# sourceMappingURL=SelectInput.messages.mjs.map
